import { Area } from 'react-easy-crop';
import { IImageSize } from 'types/components/inputs/input.interface';

const createImage = (url: string): Promise<CanvasImageSource> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', error => reject(error));
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = url;
  });

export const getCroppedImg = async (
  imageFile: File,
  crop: Area,
  height = 500,
  width = 500
): Promise<File> => {
  const image = await createImage(URL.createObjectURL(imageFile));
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  canvas.width = width;
  canvas.height = height;

  ctx?.drawImage(
    image,
    crop.x,
    crop.y,
    crop.width,
    crop.height,
    0,
    0,
    canvas.width,
    canvas.height
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => {
      if (blob) {
        const file = new File([blob], imageFile.name);
        resolve(file);
        // const reader = new FileReader();
        // reader.readAsDataURL(blob);
        // reader.onloadend = () => {
        //   console.log(reader);

        //   if (typeof reader.result === 'string') {
        //     const [header, base64String] = reader.result.split(',');
        //     console.log(header, base64String);
        //   } else {
        //     console.log('error');
        //   }
        // };
      }
    });
  });
};

export const getImageSize = (height: number, width?: number): IImageSize => ({
  width: width ?? height,
  height,
});
